export const CUSTOM_MIDDLE_BOTTOM_CONTROL = 'custom-item-control-mb';
